import { mapValues } from '../../lib/fp';

/**
 * Flexbox
 */

export const flexCenter = () => `
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const flexStack = () => `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
`;

export const flexEqualColumn = () => `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: row;
`;

/**
 * Positioning
 */

export const fixTop = () => `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
`;

export const fixBottom = () => `
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
`;

export const fixAll = () => `
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
`;

export const absTop = () => `
  position: absolute;
  top: 0;
  left: 0;
`;

export const absMiddle = () => `
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
`;

/**
 * Positioning
 */

export const iosNotch = () => `
  min-height: env(safe-area-inset-top);
  min-height: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  padding-top: constant(safe-area-inset-top);
`;

/**
 * Typography
 */

const createTypeHelper =
  (type, name) =>
  ({ theme }) => {
    const { fontSize, lineHeight, letterSpacing } = theme.typography[type][name];
    return `
    font-size: ${fontSize};
    line-height: ${lineHeight};
    letter-spacing: ${letterSpacing || 'normal'};
  `;
  };

/**
 * specific heading sizes
 */
export const headingKilo = createTypeHelper('headings', 'kilo');
export const headingMega = createTypeHelper('headings', 'mega');
export const headingGiga = createTypeHelper('headings', 'giga');
export const headingTera = createTypeHelper('headings', 'tera');
export const headingPeta = createTypeHelper('headings', 'peta');
export const headingExa = createTypeHelper('headings', 'exa');
export const headingZetta = createTypeHelper('headings', 'zetta');
export const headingYotta = createTypeHelper('headings', 'yotta');

export const subHeadingKilo = createTypeHelper('subHeadings', 'kilo');
export const subHeadingMega = createTypeHelper('subHeadings', 'mega');
export const subHeadingExa = createTypeHelper('subHeadings', 'exa');

export const textBit = createTypeHelper('text', 'bit');
export const textByte = createTypeHelper('text', 'byte');
export const textKilo = createTypeHelper('text', 'kilo');
export const textMega = createTypeHelper('text', 'mega');
export const textGiga = createTypeHelper('text', 'giga');
export const textTera = createTypeHelper('text', 'tera');
export const textPeta = createTypeHelper('text', 'peta');
export const textExa = createTypeHelper('text', 'exa');
export const textZetta = createTypeHelper('text', 'zetta');
export const textYotta = createTypeHelper('text', 'yotta');

/**
 * Utilities
 */

export const resetList = () => `
  list-style: none;
  margin: 0;
  padding: 0;
 `;

export const disableVisually = () => `
  pointer-events: none;
  box-shadow: none;
`;

export const hideVisually = () => `
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  whiteSpace: nowrap;
  width: 1px;
`;

export const createMediaQueries = mapValues((mediaExpression) => {
  const { prefix = '', suffix = '' } =
    typeof mediaExpression === 'string' ? {} : { prefix: '(min-width: ', suffix: 'px)' };

  const enhancedExpression = prefix + mediaExpression + suffix;

  return `@media ${enhancedExpression}`;
});
